import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import * as moment from "moment";
import { NotifierService } from "src/app/_services/notifier.service";
import { APIService } from "src/app/api/api.service";
import { environment } from "src/environments/environment";

declare let Jhxlsx: any;

declare let $: any;

@Component({
  selector: "consolidated-ec2-report",
  templateUrl: "./consolidated-ec2-report.component.html",
  styleUrls: ["./consolidated-ec2-report.component.css"],
})
export class ConsolidatedEc2ReportComponent implements OnInit, OnDestroy {
  @Output("hideModel") hideModel: any = new EventEmitter<void>();
  @Input("defaultDate") defaultDate: string;
  @Input("type") type: string;
  @Input("name") name: string;
  @Input("masterAccounts") masterAccounts: any;
  yearMonth: string = "";
  urlPrefix: any = localStorage.getItem("role") == "Admin" ? "admin" : "client";
  customerType: string = localStorage.getItem("customerType");
  isRecursionRunning: any;
  hasExported: boolean;

  constructor(
    private notifier: NotifierService,
    private apiServer: APIService,
    private zone: NgZone
  ) {}

  ngOnInit(): void {
    this.yearMonth =
      this.defaultDate || moment().startOf("month").format("MM-YYYY");
    $(".datetimepickerclass").val(this.yearMonth);

    setTimeout(() => {
      $(".datetimepickerclass")
        .datepicker({
          autoclose: true,
          minViewMode: 1,
          format: "mm-yyyy",
          orientation: "bottom auto",
          endDate: new Date(),
        })
        .on("changeDate", (selected: any) => {
          $(".datetimepickerclass").val(
            moment(selected["dates"][0]).format("MM-YYYY")
          );
          this.status = null;
          this.link = "";
          this.yearMonth = moment(selected["dates"][0]).format("MM-YYYY");
        });
    }, 100);
    if (this.name != "EC2") {
      this.reportcall();
    }
  }

  link: string = "";
  loading: boolean = false;
  status: string = null;
  destroyed: boolean = false;

  async requestReport(reGen: boolean = false) {
    let clientEmail: string = this.fetchSelectedClientDetails();
    let accounts: any = localStorage.getItem("accountIdData");
    let accountsObj: any = null;
    if (accounts) {
      accountsObj = JSON.parse(accounts);
      accountsObj = accountsObj.list
        .map((account: any) => {
          return account["accountId"];
        })
        .join(",");
      if (!accountsObj) {
        this.notifier.alert("Info", "", "No accounts found", "info", 5000);
        return;
      }
    } else {
      this.notifier.alert("Info", "", "No accounts found", "info", 5000);
      return;
    }
    this.loading = true;
    this.link = "";
    let data: any = {
      a: "generateEc2",
      lids: accountsObj,
      eid:
        (clientEmail != "undefined" && clientEmail) ||
        (localStorage.getItem("masterId") != "undefined" &&
          localStorage.getItem("masterId")) ||
        localStorage.getItem("eId"),
      monthYear: this.yearMonth,
      reGen: reGen,
    };

    let header: any = {
      Authorization: localStorage.getItem("t"),
    };

    let apiURL: string = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/orgreport`;

    let result: any = await this.apiServer.postDataPromis(apiURL, data, header);

    if (this.destroyed) {
      return;
    }

    if (result.s == "1" || result.status == "1") {
      this.status = result.msg;
      this.link = result["preUrl"];
      if (!result["preUrl"]) {
        setTimeout(() => {
          this.requestReport(false);
        }, 3000);
      }
      if (result.msg == "failed") {
        this.notifier.alert(
          "Info",
          "",
          result.error || result.message || result.msg || result.error_message,
          "info",
          5000
        );
      }
    } else {
      this.notifier.alert(
        "Info",
        "",
        result.error || result.message || result.msg || result.error_message,
        "info",
        5000
      );
    }

    this.loading = false;
  }

  async billingAllAccRep(reGen: boolean = false) {
    const actionMap: { [key: string]: string } = {
      S3: "generates3",
      RDS: "generaterds",
      EC2: "generateEc2",
      CFRC: "generatecfrc",
    };

    const fetchActionMap: { [key: string]: string } = {
      S3: "fetchs3details",
      RDS: "fetchRds",
      CFRC: "fetchCloudFrontData",
    };

    const selectedAction = actionMap[this.name];
    const selectedFetchAction = fetchActionMap[this.name];

    const clientEmail: string = this.fetchSelectedClientDetails();
    const accountsObj = this.getSelectedAccounts();
    if (!accountsObj.length) return;

    if (this.loading) return;
    this.loading = true;
    this.link = "";
    this.accountWiseData = {};

    if (this.name === "EC2") {
      await this.handleEc2Export(
        selectedAction,
        accountsObj,
        clientEmail,
        reGen
      );
      return;
    }

    await this.fetchAccountWiseBreakup(accountsObj, selectedFetchAction);

    if (this.name === "S3") {
      this.exportS3();
    } else if (this.name === "CFRC") {
      this.exportCFRC();
    } else if (this.name === "RDS") {
      this.exportRDS();
    }

    this.loading = false;
    this.hasExported = false;
  }

  exportS3() {
    const dict = {
      sheetName: `S3-All-Data`,
      data: [] as any[][],
    };

    // ================= HEADER =================
    dict.data.push([
      { text: "Sl. No." },
      { text: "Account Id" },
      { text: "Region" },
      { text: "Description" },
      { text: "Usage" },
      { text: "Total Cost" },
      { text: "Discount" },
      { text: "Final Cost" },
    ]);

    let i = 0;

    for (const [accountId, accountObj] of Object.entries(
      this.accountWiseData
    )) {
      if (accountObj.noData) continue;

      const list = accountObj.s3DetailsList || [];

      for (const row of list) {
        const totalCost = Number(row.totalCost || 0);

        let discount: number;
        let totalUpdatedCost: number;

        if (row.discountType && row.discountType.includes("Discounted")) {
          totalUpdatedCost = Number(row.totalUpdatedCost || totalCost);
          discount = totalCost - totalUpdatedCost;
        } else {
          discount = 0;
          totalUpdatedCost = totalCost;
        }

        dict.data.push([
          { text: i + 1 }, // Sl. No.
          { text: accountId }, // Account Id
          { text: row.region || "-" }, // Region
          { text: row.description || "-" }, // Description
          { text: Number(row.totalUsage || 0) }, // Usage
          { text: totalCost }, // Total Cost
          { text: discount }, // Discount
          { text: totalUpdatedCost }, // Final Cost
        ]);

        i++;
      }
    }

    Jhxlsx.export([dict], {
      fileName: `S3-All-Accounts-${new Date().toISOString().slice(0, 10)}`,
    });
  }

  exportCFRC() {
    const dict = {
      sheetName: `CFRC-All-Data`,
      data: [] as any[][],
    };

    // Header
    dict.data.push([
      { text: "Sl. No." },
      { text: "Account ID" },
      { text: "Region" },
      { text: "Description" },
      { text: "Usage / Hours" },
      { text: "Total Cost" },
      { text: "Discount Type" },
      { text: "Updated / MRR Cost" },
    ]);

    let i = 0;

    for (const [accountId, accountObj] of Object.entries(
      this.accountWiseData
    )) {
      if (accountObj.noData) continue;

      const list = accountObj.cloudFrontDetailsList || [];

      for (const row of list) {
        dict.data.push([
          { text: i + 1 },
          { text: accountId },
          { text: row.region || "-" },
          { text: row.description || "-" },
          { text: Number(row.totalUsage || 0) },
          { text: Number(row.totalCost || 0) },
          { text: row.discountType || "-" },
          { text: Number(row.totalUpdatedCost || 0) },
        ]);
        i++;
      }
    }
    Jhxlsx.export([dict], {
      fileName: `CFRC-${this.masterAccounts}-${this.yearMonth}`,
    });
  }

  getSelectedAccounts(): string[] {
    const accountsStr = localStorage.getItem("accountIdData");
    if (!accountsStr) {
      this.notifier.alert("Info", "", "No accounts found", "info", 5000);
      return [];
    }

    const parsed = JSON.parse(accountsStr);
    const accounts = parsed.list.map((x: any) => x.accountId);

    if (!accounts.length) {
      this.notifier.alert("Info", "", "No accounts found", "info", 5000);
      return [];
    }

    return accounts;
  }

  async handleEc2Export(
    selectedAction: string,
    accounts: string[],
    email: string,
    reGen: boolean
  ) {
    const data: any = {
      a: selectedAction,
      lids: accounts.join(","),
      eid:
        email ||
        localStorage.getItem("masterId") ||
        localStorage.getItem("eId"),
      monthYear: this.yearMonth,
      reGen: reGen,
      master: [$("#masterAccountSelect").val()],
    };

    const header: any = { Authorization: localStorage.getItem("t") };
    const apiURL: string = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/fetchmasterinfra`;

    try {
      const result = await this.apiServer.postDataPromis(apiURL, data, header);
      if (result.s === "1" || result.status === "1") {
        this.status = result.msg;
        this.link = result.preUrl;

        if (!result.preUrl) {
          setTimeout(async () => {
            await this.billingAllAccRep(false);
          }, 3000);
        }
      }
    } catch (err) {
      console.error("EC2 Export Error:", err);
      this.notifier.alert(
        "Error",
        "",
        "Failed to fetch EC2 data",
        "error",
        5000
      );
    } finally {
      this.loading = false;
    }
  }

  async fetchAccountWiseBreakup(
    accounts: string[],
    selectedFetchAction: string
  ) {
    const header = { Authorization: localStorage.getItem("t") };

    let baseURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/ec2breakup`;
    if (this.customerType === "mp")
      baseURL = `${APIService.API_ENDPOINTV3}/market/billing/subdetails`;
    if (environment.envName === "Development" && this.urlPrefix === "admin")
      baseURL = `${environment.apiURL}/${this.urlPrefix}/billing/ec2breakup`;

    for (const accountId of accounts) {
      const payload = {
        month_year: this.yearMonth,
        lid: accountId,
        userType: this.customerType || "C",
        action: selectedFetchAction,
        masterAccId: $("#masterAccountSelect").val(),
      };

      try {
        const response: any = await this.apiServer.postDataPromis(
          baseURL,
          payload,
          header
        );

        if (this.name === "S3")
          this.accountWiseData[accountId] = response.s3DetailsList?.length
            ? response
            : { noData: true };

        if (this.name === "CFRC")
          this.accountWiseData[accountId] = response.cloudFrontDetailsList
            ?.length
            ? response
            : { noData: true };

        if (this.name === "RDS")
          this.accountWiseData[accountId] = response.rdsDetailsList?.length
            ? response
            : { noData: true };
      } catch (err) {
        console.error("Fetch Error:", err);
        this.accountWiseData[accountId] = { noData: true };
      }
    }
  }

  exportRDS() {
    const cell = (value: any) => ({ text: value ?? "" });

    const pushInstanceRow = (
      sheet: any,
      index: number,
      r: any,
      accountId: string
    ) => {
      sheet.data.push([
        cell(index + 1),
        cell(accountId),
        cell(r.resourceId),
        cell(r.databaseEngine),
        cell(r.region),
        cell(r.availabilityType),
        cell(r.riApplied),
        cell(r.riType),
        cell(r.riHourlyCost ?? "-"),
        cell(Number(r.totalHours ?? 0)),
        cell(Number(r.totalCost ?? 0)),
        cell(r.isMrr),
        cell(Number(r.mrrCost ?? 0)),
      ]);
    };

    const pushStorageRow = (
      sheet: any,
      index: number,
      r: any,
      accountId: string
    ) => {
      sheet.data.push([
        cell(index + 1),
        cell(accountId),
        cell(r.resourceId),
        cell(r.databaseEngine),
        cell(r.region),
        cell(r.availabilityType),
        cell(r.riApplied),
        cell(r.riType),
        cell(r.riHourlyCost ?? "-"),
        cell(Number(r.totalHours ?? 0)),
        cell(Number(r.totalCost ?? 0)),
        cell(r.isMrr),
        cell(Number(r.mrrCost ?? 0)),
      ]);
    };

    const createSheet = (name: string, header: string[]) => {
      return {
        sheetName: name,
        data: [header.map((h) => cell(h))] as any[][],
      };
    };

    const instanceSheet = createSheet("RDS-Instances", [
      "Sl. No.",
      "Account ID",
      "Resource Name",
      "Database Engine",
      "Region",
      "Availability Type",
      "RI Applied",
      "RI Type",
      "RI Hourly Cost",
      "Usage",
      "Total Cost",
      "MRR Applied",
      "Final Cost",
    ]);

    const storageSheet = createSheet("RDS-Storage", [
      "Sl. No.",
      "Account ID",
      "Resource Name",
      "Database Engine",
      "Region",
      "Availability Type",
      "RI Applied",
      "RI Type",
      "RI Hourly Cost",
      "Usage",
      "Total Cost",
      "MRR Applied",
      "Final Cost",
    ]);

    let instIndex = 0;
    let storIndex = 0;

    for (const [accountId, acc] of Object.entries(this.accountWiseData)) {
      if (!acc || acc.noData) continue;
      if (!acc.rdsDetailsList) continue;

      for (const rds of acc.rdsDetailsList) {
        const isInstance =
          rds["resourceId"]?.includes("Usage") &&
          rds["resourceId"]?.includes(":db.");

        if (isInstance) {
          pushInstanceRow(instanceSheet, instIndex, rds, accountId);
          instIndex++;
        } else {
          pushStorageRow(storageSheet, storIndex, rds, accountId);
          storIndex++;
        }
      }
    }

    if (instanceSheet.data.length === 1) {
      instanceSheet.data.push([cell("No Instance Data Found")]);
    }

    if (storageSheet.data.length === 1) {
      storageSheet.data.push([cell("No Storage Data Found")]);
    }

    Jhxlsx.export([instanceSheet, storageSheet], {
      fileName: `RDS-All-Accounts-${new Date().toISOString().slice(0, 10)}`,
    });
  }

  accountWiseData: { [accountId: string]: any } = {};

  reportcall() {
    if (this.type == "billing") {
      this.billingAllAccRep(false);
    } else {
      this.requestReport(false);
    }
  }

  fetchSelectedClientDetails() {
    let clientList: any = localStorage.getItem("clientList");

    if (clientList && localStorage.getItem("role") == "Admin") {
      let selectedCLient: string = localStorage.getItem("selectedClientList");
      let data: any = JSON.parse(clientList);
      const client = data.find((client: any) => {
        return client["emailId"] == selectedCLient;
      });
      return client["emailId"] || null;
    } else {
      return localStorage.getItem("masterId") || localStorage.getItem("eId");
    }
  }

  downloadReport() {
    var link = document.createElement("a");
    link.download = this.link;
    link.href = this.link;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }
}
